<template>
  <div class="zj-moble-app-page">
    <mt-header class="zj-mt-header" fixed="true" slot="left">
      <mt-button slot="left" icon="back" class="nav-btn" @click="GoToRecord('first')">任务详情</mt-button>
      <!-- <mt-button slot="right" size="small">其他任务</mt-button> -->
      <mt-button slot="right" size="small" @click="GoToRecord('second')">事态反馈</mt-button>
    </mt-header>
    <div class="zj-mt-content">
      <div class="zj-mt-map">
        <ZJMobileApp :center="[EventObj.longitude,EventObj.latitude]"></ZJMobileApp>
      </div>
      <div class="zj-mt-taskinfo">
        <mt-cell title="任务详情：" :label="Task.taskName">
          <img
            slot="icon"
            src="../images/icon1.png"
          />
        </mt-cell>
        <mt-cell title="任务描述：" :label="Task.taskDesc">
          <img
            slot="icon"
            src="../images/icon2.png"
          />
        </mt-cell>
        <mt-cell title="任务地址：" :label="Task.taskAddress">
          <img
            slot="icon"
            src="../images/icon3.png"
          />
        </mt-cell>
        <mt-cell title="负责人：" :label="ChargerPerson">
          <img
            slot="icon"
            src="../images/icon4.png"
          />
        </mt-cell>
        <mt-cell title="计划响应时间：" :label="responseMinuteStr">
          <img
            slot="icon"
            src="../images/icon5.png"
          />
        </mt-cell>
      </div>
      <!-- <div class="zj-mt-rescueteam">涉及救援队人员</div> -->
    </div>
    <div class="zj-mt-footer" v-if="showFoot">
      <mt-button type="primary" @click.native="IsVisible = true" size="large">任务反馈</mt-button>
    </div>
    <mt-popup v-model="IsVisible" position="bottom" class="mint-popup">
      <mt-header title="任务反馈"></mt-header>
      <div class="filed-label">执行状态</div>
      <div class="filed-label">
        <mt-button
        v-for="item in options"
        :key="item.code"
          size="small"
          :class="{active:Task.status == item.code}"
          @click.native="OnstatusChanged(item.code)"
          v-if="item.code == 2 || item.code == 3"
        >{{item.value}}</mt-button>
      </div>
      <div class="filed-label">反馈内容</div>
      <mt-field
        label
        placeholder="填写任务执行情况的说明"
        type="textarea"
        rows="4"
        v-model="Task.content"
      ></mt-field>
      <mt-button class="popup-submit" type="primary" size="large" @click.native="submitFeedback">提交</mt-button>
    </mt-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Field, Cell, Toast, Indicator } from "mint-ui";
import { executeTask } from "@/api/src/emergency_event";
import { getDictionary } from "@/api/src/emergency_common";
import { detail as commandTaskDetail } from "@/api/src/emergency_command_task";
import { save } from "@/api/src/emergency_feedback";
import { update } from "@/api/src/emergency_command_task";
import { detail } from "@/api/src/emergency_event";
import { detail as personDetail } from "@/api/src/emergency_person";
import ZJApp from "../../../app";

import ZJMobileApp from "./component/map.vue";

Vue.component(Field.name, Field);
Vue.component(Cell.name, Cell);

export default {
  name: "EmgHome",
  controller: "UI",
  action: "Home",
  components: {
    ZJMobileApp
  },
  props: {
    query: {
      //任务执行id
      ExecutTaskId: {
        type: String,
        require: true,
        default: ""
      }
    } //,
    //   //通讯录
    //   BookId: {
    //     type: String,
    //     require: true
    //   },
    //   //事件id
    //   EventId: {
    //     type: String,
    //     require: true
    //   }
  },
  data: function() {
    return {
      EventObj:{},
      options:[],
      showFoot:false,
      Task: {
        id: "",
        taskName: "",
        taskDesc: "",
        taskAddress: "",
        responseMinute: "",
        personId:'',
        personIdTranslated: "",
        mobileNo: "",
        longitude: "",
        latitude: "",
        status: "",
        content: "",
        eventId:'',
        taskId:'',
      },
      IsVisible: false,
      msgkey: {
        emergencyFeedbackKey: "MessageKey_EmergencyFeedBack",
        emergencyFinishTaskKey: "MessageKey_EmergencyFinishTask"
      },
      oldStatus:'',
      smsPersonIdTranslated:'',
    };
  },
  created() {
    this.Init();
    if(this.query.smsPersonId){
      this.getPersonInfo()
    }
  },
  methods: {
    Init() {
      Indicator.open("加载中...");
      return ZJApp.ZJUtils.waitAll([
        () => this.GetEvent(),
        () => this.getDictionary(),
        () => this.GetTask(),
      ]).then(() => {
        Indicator.close();
      });
    },
    getPersonInfo(){
      personDetail( this.query.smsPersonId )
        .then(r => {
          r = r.data;
          this.smsPersonIdTranslated = r.name;
        })
    },
    GetTask() {
      let that = this;
      return commandTaskDetail(this.query.taskId)
      // return list({eventId: this.query.eventId,taskId:this.query.taskId,current:1,size:1})
        .then(res => {
          if (res.code == "0" && res.data != null) {
            var result = res.data;
            if(result.status == 1 || result.status == 3){
              this.showFoot = true
            }
            this.oldStatus = result.status
            // eslint-disable-next-line no-undef
            that.Task = $.extend({}, that.Task, result);
          }
        })
    },
    getDictionary() {
      return getDictionary('emergency_command_status')
        .then(res => {
          if (res.code == "0" && res.data.records != null) {
            this.options = res.data.records;
          }
        })
    },
    GetEvent() {
      return detail(this.query.eventId)
        .then(res => {
          if (res.code == "0" && res.data != null) {
            this.EventObj = res.data;
          } else {
            //TODO Toast("获取事件信息失败！");
            console.log("获取事件信息失败！");
          }
        })
        .catch(e => {
          console.log(e.msg ? e.msg : "获取事件信息失败！");
        });
    },
    OnstatusChanged(val) {
      this.Task.status = val;
    },
    GoToRecord(activeTabDom) {
      this.$router.push({
        path: "/m/emg/EventsReport",
        query: {
          personId:this.query.personId || '', 
          smsPersonId:this.query.smsPersonId || '', 
          task: JSON.stringify(this.Task),
          activeTabDom
        }
      });
    },
    submitFeedback() {
      if (this.Task.status == 1) {
        Toast({ message: "请反馈执行状态" });
        return false;
      }
      let {taskId,createUser} = this.feedback
      if(this.oldStatus == 1){
        executeTask({taskId, username:createUser }).then(r => {
            console.log(r)
            if(r.code == 0){
              this.submit()
            }else{
              Toast({ message: "任务反馈失败" });
            }
          })    
      }else{
        this.submit()
      }
     
    },
    submit(){
      let that = this;
      //插入反馈数据
      save(that.feedback)
        .then(r => {
            let code = r.code;
            if (code == 0) {
            //增加反馈成功，发送反馈成功消息
            that.$notify.broadcase({
              key: that.msgkey.emergencyFeedbackKey + that.Task.eventId,
              data: that.feedback
            });
            //更新任务状态
            let { id, status }= that.Task
            //更新任务状态
            update({ id, status })
              .then((r) => {
                let code = r.code;
                if (code == 0) {
                  //发送任务完成消息
                  console.log(
                    "broadcase : " +
                      that.msgkey.emergencyFinishTaskKey +
                      that.Task.ExecutId
                  );
                  that.$notify.broadcase({
                    key:
                      that.msgkey.emergencyFinishTaskKey + that.Task.eventId,
                    data: that.Task
                  });

                  this.IsVisible = false;

                  Toast({ message: "任务反馈成功" });
                  if(status == 3){
                    that.showFoot = false
                  }
                }
              })
              .catch(e => {
                console.error(e);
              });
          }
        })
    }
  },
  computed: {
    ChargerPerson: function() {
      return this.Task.personIdTranslated + " " + this.Task.mobileNo;
    },
    responseMinuteStr: function() {
      return this.Task.responseMinute + "分钟";
    },
    feedback: function() {
      let user = this.Task.smsPersonId ? this.smsPersonIdTranslated : this.Task.personIdTranslated;
      var feedback = {
        createUser: user,
        status: this.Task.status,
        content: this.Task.content,
        taskId: this.Task.id,
        eventId: this.Task.eventId,
        feedbackType:2,
      };
      return feedback;
    }
  }
};
</script>